const initialState = {
	userName: '',
	legalName: '',
	password: '',
	gstNum: '',
	email: '',
	phone: '',
	address1: '',
	city: '',
	state: '',
	pincode: '',
	address2: '',
};
const reducer = (state, action) => {
	switch (action.type) {
		case 'SET_VALUE':
			return {
				...state,
				...action.payload,
			};

		default:
			return state;
	}
};
const config = {
	initialState,
	reducer,
};

export default config;
